export default function labelService() {
  return function generate(viewField, engineApi) {
    viewField.metadata = viewField.metadata || {};
    return new engineApi.Element('ec-label').addAttributes(
      {
        title: viewField.title || '',
        text: viewField.text || '',
        'ng-model': engineApi.property.getNgModel(viewField),
        'ec-flex': viewField.cols || 8,
        'ng-show': engineApi.property.getVisible(viewField),
      },
      true
    );
  };
}
